import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { fetchStudentByClass } from '../../../../service/student.service';
import Label from '../../../../fl-components/Label';
import MyAvatar from '../../../../components/MyAvatar';
import UserTable from '../../../../components/tables/UserTable';
import { TableSkeleton } from '../../../../fl-components/table';
import EmptyDashboardChart from '../../../../components/EmptyDashboardChart';
import Modal from '../../../../components/common/Modal';

export default function TeacherStudents({ classDetails }) {
  const [openStudentDialog, setStudentDialog] = useState(false);
  // Selected student while clicking on student name
  const [selectedStudent, setSelectedStudent] = useState(null);
  // Student list
  const [studentList, setStudentsList] = useState([]);
  // Student loadind
  const [studentLoading, setStudentLoading] = useState(true);

  /**
   * Fetch student from api
   */
  const fetchStudentList = async () => {
    const res = await fetchStudentByClass(classDetails?.id ?? classDetails?._id);
    if (res) {
      setStudentsList(res);
      setStudentLoading(false);
    } else {
      setStudentLoading(false);
    }
  };

  useEffect(() => {
    fetchStudentList();
  }, []);

  return (
    <div style={{ marginTop: 15 }}>
      {/* eslint-disable-next-line no-nested-ternary */}
      {studentLoading ? (
        <TableSkeleton width="100%" />
      ) : studentList.length > 0 ? (
        <UserTable
          userList={studentList}
          openUserDetails={(id) => {
            setStudentDialog(true);
            setSelectedStudent(studentList.find((sl) => (sl.userId._id ?? sl.id) === id)?.userId);
          }}
          displaySelect={false}
        />
      ) : (
        <EmptyDashboardChart text="No student found" />
      )}
      {/* User details dialog */}
      {openStudentDialog && (
        <Modal
          hideCloseBtn
          open={openStudentDialog}
          onClose={() => {
            setStudentDialog(false);
            setSelectedStudent(null);
          }}
        >
          <Label
            color="success"
            sx={{ textTransform: 'uppercase', position: 'absolute', top: 24, right: 24 }}
          >
            active
          </Label>

          <Box sx={{ mb: 5 }}>
            <MyAvatar
              imageUrl={selectedStudent?.image || selectedStudent?.profileImage}
              avatarText={selectedStudent?.fullName}
              sx={{
                mx: 'auto',
                borderWidth: 2,
                borderStyle: 'solid',
                borderColor: 'common.white',
                width: { xs: 80, md: 128 },
                height: { xs: 80, md: 128 }
              }}
            />
          </Box>
          <Typography variant="subtitle1" textAlign="center">
            {selectedStudent?.fullName}
          </Typography>
          <Typography textAlign="center">
            {selectedStudent?.mobileNumber ?? selectedStudent?.email}
          </Typography>
        </Modal>
      )}
    </div>
  );
}

TeacherStudents.propTypes = {
  classDetails: PropTypes.shape({
    id: PropTypes.string,
    _id: PropTypes.string
  })
};
